'use strict';

exports.__esModule = true;

var _xregexp = require('xregexp');

var _xregexp2 = _interopRequireDefault(_xregexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE_NONSTRING = 0;
var TYPE_LETTER = 1;
var TYPE_DASH = 2;
var TYPE_PUNC = 3;
var TYPE_SPACE = 5;
var TYPE_OTHER = 1000;
var ALL_TESTS = [TYPE_DASH, TYPE_SPACE, TYPE_PUNC, TYPE_LETTER, TYPE_OTHER];

var U = {
  addTest: function addTest(name, value, test) {
    var xRegExp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (xRegExp) {
      U.regexes.set(value, new _xregexp2.default(test));
    } else if (U.isNonString(test)) {
      U.regexes.set(value, test); // assume it is a regexp;
    } else {
      U.regexes.set(value, new RegExp(test));
    }
    U.typeNames.set(value, name);
  },
  charsIn: function charsIn(str) {
    // the unique chars in a string, as a Set
    if (U.isNonString(str)) {
      throw new Error('charsIn passed non-string');
    }
    return str.split('').reduce(function (s, c) {
      s.add(c);
      return s;
    }, new Set());
  },
  namesFor: function namesFor(set) {
    var s = new Set();
    set.forEach(function (member) {
      if (U.typeNames.has(member)) {
        s.add(U.typeNames.get(member));
      }
    });
    return s;
  },
  isMadeOf: function isMadeOf(phrase) {
    var tests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_TESTS;

    if (U.isNonString(phrase)) {
      throw new Error('isMadeOf() not passed string');
    }
    var testOther = null;

    var subTests = tests.reduce(function (s, test) {
      if (test === TYPE_OTHER) {
        testOther = test;
      } else {
        s.add(test);
      }
      return s;
    }, new Set());

    return Array.from(U.charsIn(phrase).values()).reduce(function (s, char) {
      var found = Array.from(subTests.values()).reduce(function (found, testNum) {
        if (found) {
          return found;
        }
        if (U.regexes.has(testNum)) {
          var re = U.regexes.get(testNum);
          if (!(re && re.test)) {
            console.log('bad re: ', re);
            return false;
          }
          if (re.test(char)) {
            return testNum;
          }
        }
        return false;
      }, false);
      if (found) {
        s.add(found);
      } else if (testOther) {
        s.add(TYPE_OTHER);
      }
      return s;
    }, new Set());
  },
  isNonString: function isNonString(str) {
    return typeof str !== 'string';
  },

  regexes: new Map([[TYPE_LETTER, new _xregexp2.default('^[0-9\\pL]+$')], [TYPE_SPACE, /^[ ]+$/], [TYPE_DASH, /^-$/], [TYPE_PUNC, /^[.?!,-]+$/]]),
  getType: function getType(str) {
    var tests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_TESTS;

    if (U.isNonString(str)) {
      return TYPE_NONSTRING;
    }
    var out = null;

    tests.forEach(function (testNum) {
      if (testNum === TYPE_OTHER) {
        return;
      }
      var re = U.regexes.get(testNum);
      if (!(re && re.test)) {
        console.log('getType: bad testNum:', testNum, 're === ', re);
        return;
      }
      if (!out) {
        if (re.test(str)) {
          out = testNum;
        }
      }
    });
    return out || TYPE_OTHER;
  },
  report: function report(str) {
    var tests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_TESTS;

    if (U.isNonString(str)) {
      throw new Error('report not passed string');
    }
    return str.split('').map(function (char, i) {
      return [i, char, U.getType(char, tests)];
    });
  },

  typeNames: new Map([[TYPE_NONSTRING, 'non-string'], [TYPE_LETTER, 'letter'], [TYPE_DASH, 'dash'], [TYPE_PUNC, 'punc'], [TYPE_SPACE, 'space'], [TYPE_OTHER, 'other']]),
  TYPE_OTHER: TYPE_OTHER,
  TYPE_NONSTRING: TYPE_NONSTRING,
  TYPE_PUNC: TYPE_PUNC,
  TYPE_DASH: TYPE_DASH,
  TYPE_LETTER: TYPE_LETTER,
  TYPE_SPACE: TYPE_SPACE
};
exports.default = U;
module.exports = exports['default'];